import {BrowserModule} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, HostListener, NgModule} from '@angular/core';
import {HttpModule} from '@angular/http';
import {IonicStorageModule} from '@ionic/storage';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';

import {MyApp} from './app.component';
import {SuperTabsModule} from '../components/ionic2-super-tabs/src';

import {FileTransfer, FileTransferObject} from '@ionic-native/file-transfer';

import {ApiProvider} from '../providers/api/api';
import {AlertService} from '../providers/util/alert.service';
import {SettingsProvider} from '../providers/settings';
import {AuthenticationProvider} from '../providers/authentication';
import {LoaderProvider} from "../providers/loader";
import {ConstantProvider} from '../providers/constants';
import {PopoverComponent} from "../components/popover/popover";
import {DirectivesModule} from "../directives/directives.module";
import {ClienteModel} from "../model/cliente.model";
import {PedidoModel} from "../model/pedido.model";
import {ProdutoModel} from "../model/produto.model";
import {MarcacaoModel} from "../model/marcacao.model";

import {ApiPromise} from "../providers/promises/api.promise";
import {IonicSelectableModule} from 'ionic-selectable';
import {BrMaskerModule} from 'brmasker-ionic-3';

import {statusNFService} from '../providers/util/statusNF.service';
import {selectRadioService} from "../providers/util/selectRadio.service";
import {MenuProvider} from '../providers/menu/menu';
import {formatNumberService} from "../providers/util/formatNumber.service";
import {CurrencyPipe} from "@angular/common";
import {PedidoParcelaModel} from "../model/pedido-parcela.model";
import {MarcacaoBlocoModel} from "../model/marcacao-bloco.model";
import {ChatService} from "../providers/chat-service";

@NgModule({
  declarations: [
    MyApp,
    PopoverComponent
  ],
  imports: [
    BrowserModule,
    IonicSelectableModule,
    HttpModule,
    BrMaskerModule,
    DirectivesModule,
    IonicModule.forRoot(MyApp, {
      platforms: {
        ios: {
          swipeBackEnabled: false
        }
      }
    }),
    SuperTabsModule.forRoot(),
    IonicStorageModule.forRoot({
      name: '_lcm',
      driverOrder: ['websql', 'indexeddb', 'sqlite']  //'indexeddb', 'sqlite', 'websql'
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    PopoverComponent
  ],
  providers: [
    LoaderProvider,
    SettingsProvider,
    ConstantProvider,
    CurrencyPipe,
    ClienteModel,
    PedidoModel,
    ProdutoModel,
    PedidoParcelaModel,
    MarcacaoModel,
    MarcacaoBlocoModel,
    AuthenticationProvider,
    ApiProvider,
    AlertService,
    ChatService,
    statusNFService,
    selectRadioService,
    formatNumberService,
    StatusBar,
    SplashScreen,
    ApiPromise,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    MenuProvider,
    FileTransfer,
    FileTransferObject
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts